import PropTypes from 'prop-types';

module.exports = scrollerMenu => {
  scrollerMenu.propTypes = {
    children: PropTypes.any,
    dishId: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
    ]),
    onScroll: PropTypes.func,
    onScrollingTitleAction: PropTypes.func,
    theme: PropTypes.any,
    dishesData: PropTypes.any,
  };

  scrollerMenu.defaultProps = {
    children: null,
    dishId: 0,
    onScroll: () => null,
    theme: 'default',
  };
};



// WEBPACK FOOTER //
// ./src/container/dish-scroller-menu/initProps.js